module.exports = __webpack_public_path__ + "img/1524023730.9881a6f8.jpg";